import { struct } from 'io-ts/Decoder';

import { EntityId } from '../../../integration/EntityId';

export const Params = struct({
	entityId: EntityId,
});
